import axios from "axios";
import React, { useEffect, useState } from "react";
import L from "leaflet";
import marker from "./images/Vs.png";
import { variables } from "../Variables.js";
import { parse } from "papaparse";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";

export function StoreLocator() {
  const [storeData, setstoreData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://docs.google.com/spreadsheets/d/e/2PACX-1vQZohTvHwu9xeriuPi2ZDrrusZrSkx0J8muk_E2ThSHvQny47QBaLkd4ZdNYebF6zGEbZgeyCijukUS/pub?gid=0&single=true&output=csv"
        );
        const parsedData = parse(response.data, { header: true }).data;
        setstoreData(parsedData);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  const position = [40.24155837181681, -74.83699755092397];
  const myIcon = new L.Icon({
    iconUrl: marker,
    iconRetinaUrl: marker,
    popupAnchor: [-0, -0],
    iconSize: [45, 45],
  });

  return (
    <div id="maps" className="container bg-dark imgNoRadius">
      <h3 className="colorBGBlack">Store Locator</h3>
      <div className="displayGrid wide100per ">
        <div className="gridRow1 gridCol1 table-dark pb5px hFC">
          <div className="colorBGBlack">
            {isLoading ? (
              "Loading..."
            ) : (
              <MapContainer
                center={position}
                zoom={5}
                scrollWheelZoom={true}
                className="h75vh imgNoRadius"
              >
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  url="https://tiles.stadiamaps.com/static/alidade_smooth_dark.png"
                  className="imgNoRadius"
                />

                {storeData.map((coords, index) => (
                  <Marker
                    position={[coords.lat, coords.lng]}
                    icon={myIcon}
                    key={index}
                  >
                    <Popup>
                      <h4>{coords.name}</h4>
                      <p>{coords.address}</p>
                      <p>{coords.city}</p>
                      <p>{coords.country}</p>
                      {coords.website && (
                        <a href={coords.website} target="_blank">
                          Visit Website
                        </a>
                      )}
                    </Popup>
                  </Marker>
                ))}
              </MapContainer>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
